/**
 * Canonical display-name derivation for a person, shared by every screen
 * that reads a name.
 *
 * Rule: `${first_name} ${last_name}`.trim() -- when non-empty -- otherwise
 * email.
 *
 * The stored display_name field is deliberately NOT consulted here, and
 * nothing writes it any more. Every write site used to recompute display_name
 * from first_name/last_name, which meant it could never hold a genuine
 * preferred name -- it was a derived cache pretending to be a source of
 * truth. Nothing queries or sorts on display_name in Firestore either (no
 * where, no orderBy, no index), so keeping it in sync bought nothing but the
 * risk of drift (matchie-dev users/NklCKzl0RZdiEasiuKYKX6vpFUF3 showed
 * "Matchie Noldor1" in the survey progress modal while the respondents list
 * showed "Matchie Daniel" for the same person, because display_name was set
 * once on 2026-04-08 and never recomputed when first_name/last_name were
 * corrected). Deriving the name at read time makes that drift structurally
 * impossible instead of merely policed by remembering every write site. Do
 * not reinstate a stored display_name in this precedence chain.
 */

/**
 * Derive the name to show for a person, following the canonical rule.
 * Use this at every READ site.
 */
export function deriveDisplayName(
	firstName: string | null | undefined,
	lastName: string | null | undefined,
	email: string | null | undefined,
): string {
	const fullName = `${firstName || ""} ${lastName || ""}`.trim();
	if (fullName) {
		return fullName;
	}

	return email || "";
}
